interface Navigator {
  msSaveOrOpenBlob: (blob: Blob) => void
}

const hasMsSaveOrOpenBlob = (navigator: any): navigator is Navigator => {
  return navigator?.msSaveOrOpenBlob
}

/**
 * It is necessary to create a new blob object with mime-type explicitly set
 * otherwise only Chrome works like it should
 * @param blob
 */
const createBlob = (blob: Blob | Uint8Array<ArrayBuffer>, type: string) =>
  new Blob([blob], { type })

export const saveFile =
  (name: string, type = "application/pdf", fileExt = "pdf") =>
  (blob: Blob | Uint8Array<ArrayBuffer> | void) => {
    if (!blob) return

    const pdfBlob = createBlob(blob, type)
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (hasMsSaveOrOpenBlob(window.navigator)) {
      window.navigator.msSaveOrOpenBlob(pdfBlob)
      return
    }
    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(pdfBlob)
    const link = document.createElement("a")
    link.href = data
    link.download = `${name}.${fileExt}`
    link.click()
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data)
    }, 100)
  }

export const openFile = (blob: Blob, mimeType: string): WindowProxy | null => {
  const dataUrl = window.URL.createObjectURL(createBlob(blob, mimeType))
  return window.open(dataUrl)
}

export const printFilePDF = (blob: Blob) => {
  const pdfWindow = openFile(blob, "application/pdf")
  if (pdfWindow) {
    pdfWindow.print()
  }
}
